/** @mixin listItemResetMixin */
/**
 * Defensive reset styles for list items.
 *
 * @example
 * import { listItemResetMixin } from '@zillow/constellation';
 *
 * const Component = styled.li`
 *     ${listItemResetMixin}
 * `;
 *
 * <Component />
 *
 * @method
 * @return {CSSObject}
 */
export var listItemResetMixin = function listItemResetMixin() {
  return "\n    margin: 0;\n";
};